module.exports = __webpack_public_path__ + "static/media/Counter.400a064a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/iLocal-Delivery-Icons/Counter.svg
// module id = 1843
// module chunks = 0